<template>
    <div>

        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-pencil"></i></template> Etage bearbeiten
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Etage bearbeiten
                </template>

                <loading v-show="loading"></loading>

                <div v-show="!loading">

                    <div class="flex justify-end">
                        <confirm-dialog @confirmed="removeFloor">
                            <button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Etage löschen</button-delete>
                            <template slot="header">Etage löschen</template>
                            <template slot="question">Soll die Etage wirklich gelöscht werden?</template>
                            <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Etage löschen</button-delete></template>
                        </confirm-dialog>
                    </div>

                    <input-text class="mb-2" v-model="name">
                        Name der Etage
                    </input-text>
                  <input-text class="mb-2" v-model="address">
                    Adresse
                  </input-text>

                    <toggle-group class="mb-2" v-model="isBlocked">
                        Blocked
                        <template v-slot:helper>When aktiviert, wird die Etage blockiert und dem Nutzer nicht angezeigt.</template>
                    </toggle-group>

                    <navigation :zone="zone" v-if="zone"></navigation>

                    <div class="mb-2">
                        Lageplan:
                        <input type="file" ref="map" @change="handleFileUpload()" class="border">
                        <span class="text-gray-500">max. 1 MB</span>
                    </div>

                    <div class="mb-4 flex" v-show="mapLink">
                        <img :src="mapLink" class="h-25 border" alt="Karte">
                        <confirm-dialog @confirmed="removeMap">
                            <i class="fa fa-times"></i>
                            <template slot="header">Karte löschen</template>
                            <template slot="question">Soll die Karte wirklich entfernt werden?</template>
                            <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template>Löschen</button-delete></template>
                        </confirm-dialog>
                    </div>

                    <div class="flex justify-end">
                        <button-primary @click="save"><template slot="icon"><i class="fa fa-save"></i></template> Speichern</button-primary>
                    </div>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import Modal from "./Modal";
import ButtonDelete from "./UI/ButtonDelete";
import Loading from "./UI/Loading";
import ConfirmDialog from "./UI/ConfirmDialog";
import InputText from "./UI/InputText";
import Navigation from "./Navigation";
import ButtonSecondary from "./UI/ButtonSecondary";
import Toggle from "./UI/Toggle.vue";
import ToggleGroup from "./UI/ToggleGroup.vue";

export default {
    name: "FloorEdit",
    components: {
        ToggleGroup,
        Toggle,
        ButtonSecondary, Navigation, InputText, ConfirmDialog, Loading, ButtonDelete, Modal, ButtonPrimary},

    props: ['id'],

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
        address:'',
        isBlocked: false,
        mapLink: '',
        zone: null,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.load();
        },
        load() {
            this.loading = true;
            window.axios.get(`/admin/floors/${this.id}`)
                .then(result => {
                    this.name = result.data.data.name;
                    this.address = result.data.data.address;
                    this.floor = result.data.data;
                    this.mapLink = result.data.data.map_link;
                    this.isBlocked = result.data.data.is_blocked ?? false;
                    this.loading = false;
                });
        },
        save() {
            window.axios.post(`/admin/floors/${this.id}`, {
                _method: 'put',
                name: this.name,
                address: this.address,
                is_blocked: this.isBlocked,
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$emit('updated');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        handleFileUpload() {
            let map = this.$refs.map.files[0];
            let formData = new FormData();
            formData.append('map', map);
            formData.append('_method', 'put');
            window.axios
                .post(`/admin/floors/${this.id}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.mapLink = response.data.data.map_link;
                    this.$emit('updatd');

                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        removeMap() {
            this.loading = true;
            window.axios.post(`/admin/floors/${this.id}`, {
                _method: 'put',
                map: '',
            }).then(() => {
                this.loading = false;
                this.mapLink = null;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        removeFloor() {
            this.loading = true;
            window.axios.post(`/admin/floors/${this.id}`, {
                _method: 'delete',
            }).then(() => {
                window.location.href = '/admin/pages/floors';
                this.loading = false;
                this.$emit('updated');
            }).catch(error => {
                this.loading = false;
                this.$emit('updated');
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
